export const formatPhoneNumber = (
	telephonePrefix: string | null | undefined,
	phoneNumber: string | null | undefined
): string => `${(telephonePrefix ?? '').replace(/\s/g, '')}${phoneNumber ?? ''}`;
